import { useState, useEffect, } from "react";
import { TratamientoAdminUpdate } from "./TratamientoAdminUpdate";
import { TratamientoAdminDelete } from "./TratamientoAdminDelete";
import { Link, useLoaderData, useNavigate } from "react-router-dom";

import Select from "react-select";

import { OpcionesEstadosTratamientos } from './OpcionesEstadosTratamientos';

import { GetAndUpdateUser } from "./GetAndUpdateUser";

import * as API from "../services/tratamientosAdmin";
import * as APIPACIENTE from "../services/pacientes";
import * as APIESPECIALISTA from "../services/especialistas";
import * as APIPSICOTERAPIA from "../services/psicoterapia";
import * as APINUTRICION from "../services/nutricion";
import * as APIENTRENAMIENTO from "../services/entrenamiento";
import * as APIMINDFULNESS from "../services/mindfulness";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getTratamientoById(params.tratamientoId);
}

export function TratamientoAdminEdit() {
  const tratamiento = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const navigate = useNavigate();

  const pacienteId = tratamiento.meta?.paciente;
  const [pacienteNiceName, setPacienteNiceName] = useState([]);
  const [date, setDate] = useState(tratamiento.meta?.fecha);
  const [estado, setEstado] = useState(tratamiento.meta?.estado);

  const [otrosEstados, setOtrosEstados] = useState({
    psicEstado: "",
    nutrEstado: "",
    entrEstado: "",
    mindEstado: ""
  });

  let slug = "tr-us-" + pacienteId + "-fe-" + date;

  const [loading, setLoading] = useState(false);
  const [especialistas, setEspecialistas] = useState([]);

  const [medico, setMedico] = useState([]);
  const [psicologo, setPsicologo] = useState([]);
  const [nutricion, setNutricion] = useState([]);
  const [entrenamiento, setEntrenamiento] = useState([]);
  const [mindfulness, setMindfulness] = useState([]);

  const [medicoSelected, setMedicoSelected] = useState(
    tratamiento.meta?.medico
  );
  const [psicoHospSelected, setPsicoHospSelected] = useState(
    tratamiento.meta?.psicohosp
  );
  const [psicologoSelected, setPsicologoSelected] = useState(
    tratamiento.meta?.psicologo
  );
  const [nutricionSelected, setNutricionSelected] = useState(
    tratamiento.meta?.nutricion
  );
  const [entrenamientoSelected, setEntrenamientoSelected] = useState(
    tratamiento.meta?.entrenamiento
  );
  const [mindfulnessSelected, setMindfulnessSelected] = useState(
    tratamiento.meta?.mindfulness
  );

  const [especialistasSelected, setEspecialistasSelected] = useState(
    tratamiento.meta?.especialistas
  );

  let tratamientoId = tratamiento.id;

  // Carga estados de tratamiento de cada grupouseEffect(() => {
    useEffect(() => {
      const loadEstados = async () => {
        try {
          // Realiza todas las llamadas a la API en paralelo
          const [responseEstadoPsic, responseEstadoNutr, responseEstadoEntr, responseEstadoMind] = await Promise.all([
            APIPSICOTERAPIA.getAllPsicoterapiaByTax(tratamiento.id),
            APINUTRICION.getAllNutricionByTax(tratamiento.id),
            APIENTRENAMIENTO.getAllEntrenamientoByTax(tratamiento.id),
            APIMINDFULNESS.getAllMindfulnessByTax(tratamiento.id),
          ]);
    
          // Obtener el meta.psicEstado del objeto con el mayor valor de meta.psicNumses
          const psicEstadoUltimo = responseEstadoPsic.reduce((max, item) => 
            item.meta.psicNumses > max.meta.psicNumses ? item : max, 
            responseEstadoPsic[0] || { meta: { psicEstado: '', psicNumses: -Infinity } }
          ).meta.psicEstado;
    
          // Obtener el meta.nutrEstado del objeto con el mayor valor de meta.nutrNumses
          const nutrEstadoUltimo = responseEstadoNutr.reduce((max, item) => 
            item.meta.nutrNumses > max.meta.nutrNumses ? item : max, 
            responseEstadoNutr[0] || { meta: { nutrEstado: '', nutrNumses: -Infinity } }
          ).meta.nutrEstado;
    
          // Obtener el meta.entrEstado del objeto con el mayor valor de meta.entrNumses
          const entrEstadoUltimo = responseEstadoEntr.reduce((max, item) => 
            item.meta.entrNumses > max.meta.entrNumses ? item : max, 
            responseEstadoEntr[0] || { meta: { entrEstado: '', entrNumses: -Infinity } }
          ).meta.entrEstado;
    
          // Obtener el meta.mindEstado del objeto con el mayor valor de meta.mindNumses
          const mindEstadoUltimo = responseEstadoMind.reduce((max, item) => 
            item.meta.mindNumses > max.meta.mindNumses ? item : max, 
            responseEstadoMind[0] || { meta: { mindEstado: '', mindNumses: -Infinity } }
          ).meta.mindEstado;
    
          setOtrosEstados({
            psicEstado: psicEstadoUltimo,
            nutrEstado: nutrEstadoUltimo,
            entrEstado: entrEstadoUltimo,
            mindEstado: mindEstadoUltimo
          });
        } catch (error) {
          console.error('Error al cargar datos:', error);
          // Maneja el error según tus necesidades
        }
      };
    
      // Llama a la función
      loadEstados();
    }, [tratamiento]);

  // Load Paciente Nice Name
  useEffect(() => {
    const loadPacienteNiceName = async () => {
      // Await make wait until that
      // promise settles and return its result
      const response = await APIPACIENTE.getPacienteByID(pacienteId);

      let pacienteFullName = response.last_name + ", " + response.first_name;

      // After fetching data stored it in posts state.
      setPacienteNiceName(pacienteFullName);
    };

    // Call the function
    loadPacienteNiceName();
  }, [pacienteId]);

  // 1.Load all Especialistas
  useEffect(() => {
    const loadEspecialistas = async () => {
      // Till the data is fetch using API
      // the Loading page will show.
      setLoading(true);

      // Await make wait until that
      // promise settles and return its result
      const response = await APIESPECIALISTA.getAllEspecialistas();

      // After fetching data stored it in posts state.
      setEspecialistas(response);

      // Closed the loading page
      setLoading(false);
    };

    // Call the function
    loadEspecialistas();
  }, []);

  // 2.Map all Especialistas by especialidad to create the options for multiselect
  useEffect(() => {
    const medicinalist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "medicina")
    );
    const medicinaListSelect = medicinalist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setMedico(medicinaListSelect);

    const psicologialist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "psicologia")
    );
    const psicologiaListSelect = psicologialist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setPsicologo(psicologiaListSelect);

    const nutricionlist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "nutricion")
    );
    const nutricionListSelect = nutricionlist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setNutricion(nutricionListSelect);

    const entrenamientolist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "entrenamiento")
    );
    const entrenamientoListSelect = entrenamientolist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setEntrenamiento(entrenamientoListSelect);

    const mindfulnesslist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "mindfulness")
    );
    const mindfulnessListSelect = mindfulnesslist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setMindfulness(mindfulnessListSelect);
  }, [especialistas]);

  // 3.Create an array of Ids of selected Especialistas
  useEffect(() => {
    const allSelected = medicoSelected.concat(
      psicoHospSelected,
      psicologoSelected,
      nutricionSelected,
      entrenamientoSelected,
      mindfulnessSelected
    );
    const allSelectedId = allSelected.map((field) => field.value);

    setEspecialistasSelected(allSelectedId.toString());
  }, [
    medicoSelected,
    psicoHospSelected,
    psicologoSelected,
    nutricionSelected,
    entrenamientoSelected,
    mindfulnessSelected,
  ]);

  const submitTreatment = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await TratamientoAdminUpdate(
        pacienteId,
        date,
        estado,
        slug,
        medicoSelected,
        psicoHospSelected,
        psicologoSelected,
        nutricionSelected,
        entrenamientoSelected,
        mindfulnessSelected,
        especialistasSelected,
        tratamientoId
      ).then(
        (val) => {
          try {
            GetAndUpdateUser(pacienteId, tratamientoId).then(
              (val) => {
                //console.log(val);
                window.location.replace(`../${tratamientoId}`);
              },
              (error) => {
                console.log(error);
              }
            );
          } catch (err) {
            console.log(err);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteTratamiento = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await TratamientoAdminDelete(tratamientoId).then(
        (val) => {
          try {
            GetAndUpdateUser(pacienteId, tratamientoId, true).then(
              (val) => {
                navigate(`../pacientes/${pacienteId}`);
                //window.location.replace(`../${tratamientoId}`);
                console.log(val);
              },
              (error) => {
                console.log(error);
              }
            );
          } catch (err) {
            console.log(err);
          }
        },
          
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        {tratamiento.length === 0 ? (
          <div>Cargando...</div>
        ) : (
          <form id='formUpdatelement' onSubmit={submitTreatment}>
            <fieldset id='disabledContainer'>
            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='user'>Paciente</label>
                <div className='control'>
                  <input
                    className='input'
                    id='user'
                    required
                    disabled
                    readOnly
                    type='text'
                    value={pacienteNiceName}
                  />
                </div>
              </div>

              <div className='field'>
                <label htmlFor='date'>Fecha</label>
                <div className='control'>
                  <input
                    className='input'
                    id='date'
                    required
                    type='date'
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div>
              </div>

              <div className='field'>
                <label htmlFor='psicologo'>Psicólogos</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='psicologo'
                    name='psicologo'
                    options={psicologo}
                    placeholder='Seleccionar Especialistas'
                    onChange={setPsicologoSelected}
                    value={psicologoSelected}
                  />
                </div>
              </div>

              <div className='field'>
                  <label htmlFor='estado'>Estado de seguimiento Tratamiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='estado'
                        name='estado'
                        {...(otrosEstados.psicEstado === '' ? { onChange: (e) => setEstado(e.target.value) } : {})}
                        value={otrosEstados.psicEstado || estado || ''}
                        readOnly={otrosEstados.psicEstado !== ''}
                        disabled={otrosEstados.psicEstado !== ''}
                        
                      >
                        <option value='' disabled={otrosEstados.psicEstado !== ''}>Sin datos</option>
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

              <div className='field'>
                <label htmlFor='nutricion'>Nutricionistas</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='nutricion'
                    name='nutricion'
                    options={nutricion}
                    placeholder='Seleccionar Especialistas'
                    onChange={setNutricionSelected}
                    value={nutricionSelected}
                  />
                </div>
              </div>

              <div className='field'>
                  <label htmlFor='nutrEstado'>Estado de seguimiento Nutrición</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEstado'
                        readOnly
                        disabled
                        name='nutrEstado'
                        value={otrosEstados.nutrEstado}
                      >
                        <option value='' disabled={otrosEstados.nutrEstado !== ''}>Sin datos</option>
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

              <div className='field'>
                <label htmlFor='entrenamiento'>Entrenadores</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='entrenamiento'
                    name='entrenamiento'
                    options={entrenamiento}
                    placeholder='Seleccionar Especialistas'
                    onChange={setEntrenamientoSelected}
                    value={entrenamientoSelected}
                  />
                </div>
              </div>

              <div className='field'>
                  <label htmlFor='entrEstado'>Estado de seguimiento Entrenamiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='entrEstado'
                        readOnly
                        disabled
                        name='entrEstado'
                        value={otrosEstados.entrEstado}
                      >
                        <option value='' disabled={otrosEstados.entrEstado !== ''}>Sin datos</option>
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

              <div className='field'>
                <label htmlFor='mindfulness'>Mindfulness</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='mindfulness'
                    name='mindfulness'
                    options={mindfulness}
                    placeholder='Seleccionar Especialistas'
                    onChange={setMindfulnessSelected}
                    value={mindfulnessSelected}
                  />
                </div>
              </div>

              <div className='field'>
                  <label htmlFor='mindEstado'>Estado de seguimiento Mindfulness</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='mindEstado'
                        readOnly
                        disabled
                        name='mindEstado'
                        value={otrosEstados.mindEstado}
                      >
                        <option value='' disabled={otrosEstados.mindEstado !== ''}>Sin datos</option>
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className='field'>
                <label htmlFor='medico'>Médicos</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='medico'
                    name='medico'
                    options={medico}
                    placeholder='Seleccionar Especialistas'
                    onChange={setMedicoSelected}
                    value={medicoSelected}
                  />
                </div>
              </div>

              <div className='field'>
                <label htmlFor='psicohosp'>Psicólogos con acceso temporal Hospital</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='psicohosp'
                    name='psicohosp'
                    options={psicologo}
                    placeholder='Seleccionar Especialistas'
                    onChange={setPsicoHospSelected}
                    value={psicoHospSelected}
                  />
                </div>
              </div>

              </div>
            </fieldset>
          </form>
        )}
      </div>
      <div id='actions'>
        <button
          className='button is-link'
          id='saveButton'
          form='formUpdatelement'
          type='submit'
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        <Link
          className='button is-link is-light'
          to={`../pacientes/${pacienteId}/tratamientos/${tratamiento.id}`}
        >
          Cancelar
        </Link>
        <button
          className='button is-danger'
          id='deleteButton'
          onClick={deleteTratamiento}
          disabled={isDeletingButton}
        >
          {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
      </div>
    </>
  );
}
